import NativeStorage from "./native";
export default new NativeStorage("sessionStorage");
//# sourceMappingURL=session.js.map